import React from "react";

export const CompareProductButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    style={{ display: "block" }}
    className="btn-container"
    data-testid="variation-btn-container"
  >
    {children}
  </div>
);

export const ListOutletButton = ({
  width,
  children,
}: {
  width: number;
  children: React.ReactNode;
}) => (
  <div
    className="btn-container"
    style={width >= 600 ? {} : { marginLeft: "-30px" }}
    data-testid="variation-btn-container"
  >
    {children}
  </div>
);

export const GridOutletOrQuoteButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    style={{ padding: "0px" }}
    className="btn-container"
    data-testid="variation-btn-container"
  >
    {children}
  </div>
);

export const ListQuoteButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    style={{ maxWidth: "150px" }}
    className="btn-container"
    data-testid="variation-btn-container"
  >
    {children}
  </div>
);

// Using inline styles to avoid hydration mismatch issues
export const CustomizableButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    style={{ padding: "0px" }}
    className="btn-container"
    data-testid="variation-btn-container"
  >
    {children}
  </div>
);

// Using inline styles to avoid hydration mismatch issues
export const CustomizableListButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    className="btn-container"
    data-testid="variation-btn-container"
    style={{ padding: 0, maxWidth: "152px" }}
  >
    {children}
  </div>
);

export const DefaultButton = ({ children }: { children: React.ReactNode }) => (
  <div className="btn-container" data-testid="variation-btn-container">
    {children}
  </div>
);
